export const locale = {
    lang: 'pl',
    data: {
        'Created at': 'Data dodania',
        'Description': 'Opis',
        'Additional info': 'Dodatkowe informacje',
        'Customers': 'Klienci',
        'Cards': 'Karty',
        'History': 'Historia',
        'serviceName': 'Usługa',
        'All services': 'Wszystkie usługi',
        'balance': 'Punkty',
        'expirationDate': 'Data wygaśnięcia',
        'addedAt': 'Data dodania',
        'New item was added to cart.': 'Nowa pozycja została dodana do karty.',
        'The card was created': 'Karta została utworzona.',
        'Entrance was accepted.': 'Wejście zostało zaakceptowane.',
        'acceptedBy': 'Zaakceptowane przez',
        'cardNumber': 'Numer karty',
        'Entrance date': 'Data wejścia',
        'HISTORY': 'HISTORIA',
        'ADD SERVICE': 'DODAJ USŁUGĘ',
        'Users online': 'Użytkownicy online',
        'EXIT': 'WYJŚCIE',
        'Exit card': 'Wyjście karty'
    }
};
